import React from 'react';
import { Cron } from 'react-js-cron';
import 'react-js-cron/dist/styles.css';
import { EventTarget } from './types';

interface IProps {
  value: string;
  name: string;
  onChange: (e: EventTarget) => void;
  disabled: boolean;
}

export function CronExpressionEditor(props: IProps) {
  const setValue = (expression: string) => {
    const e = { target: { name: props.name, value: expression } };

    props.onChange(e);
  };

  return (
    <div>
      <span>{props.value}</span>
      <Cron value={props.value} setValue={setValue} clearButton={false} disabled={props.disabled} humanizeLabels />
    </div>
  );
}
